import React from 'react';
import { DirectionArrowSVG } from '../../utils/helpers';

const DirectionPicker = ({ value = 0, onChange, label = "Direction" }) => {
    const directions = [
        { label: 'N', degrees: 0.0 },
        { label: 'NNE', degrees: 22.5 },
        { label: 'NE', degrees: 45.0 },
        { label: 'ENE', degrees: 67.5 },
        { label: 'E', degrees: 90.0 },
        { label: 'ESE', degrees: 112.5 },
        { label: 'SE', degrees: 135.0 },
        { label: 'SSE', degrees: 157.5 },
        { label: 'S', degrees: 180.0 },
        { label: 'SSW', degrees: 202.5 },
        { label: 'SW', degrees: 225.0 },
        { label: 'WSW', degrees: 247.5 },
        { label: 'W', degrees: 270.0 },
        { label: 'WNW', degrees: 292.5 },
        { label: 'NW', degrees: 315.0 },
        { label: 'NNW', degrees: 337.5 },
    ];

    return (
        <div className="mb-6">
            <label className="block text-sm font-medium text-custom-light-grey mb-3">
                {label}
            </label>
            
            <div className="flex flex-wrap gap-1">
                {directions.map((direction) => {
                    const isSelected = value === direction.degrees;
                    
                    return (
                        <button
                            key={direction.degrees}
                            type="button"
                            onClick={() => onChange(direction.degrees)}
                            className={`
                                flex flex-col items-center justify-center
                                px-2 py-2 rounded
                                transition-all duration-150
                                flex-shrink-0
                                w-[calc(12.5%-0.25rem)] 
                                border 
                                hover:bg-custom-charcoal
                                ${isSelected 
                                    ? 'text-custom-light-blue border-custom-light-blue bg-custom-charcoal' 
                                    : 'border-transparent hover:bg-custom-charcoal'
                                }
                            `}
                        >
                            <DirectionArrowSVG 
                                degrees={direction.degrees} 
                                size={16} 
                                color={isSelected ? '#13a4ec' : '#9ca3af'} 
                            />
                            <span className="text-xs font-semibold mt-0.5">{direction.label}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default DirectionPicker;